import {
  List,
  type List as ListType,
  type Map as MapType,
} from "immutable";
import { createSelector } from "reselect";
import type { State } from "../../store";
import type { DropDownType, Dictionaries } from "../../reducers/dictionaries";

// eslint-disable-next-line import/prefer-default-export
export const getDictionary = createSelector(
  (state: State, dictionary: Dictionaries) => (state.dictionaries as unknown as DropDownType).getIn(["dropdownLists", dictionary], List()),
  (dropdownList: ListType<MapType<string, string>>) => dropdownList
    .toArray()
    .map((item: any) => item.toObject())
);
